export const version = {
  "version": "1.0.0",
  "hash": "179388011859970"
};
